import { Box, IconButton, Typography } from "@mui/material";
import { MdKeyboardArrowRight } from "react-icons/md";
import numberFormat from "../../../components/globalFunction/prettierNumber";
import moment from "moment";

const Client = ({ data, action }) => {
  const calculateTotalPrice = (data) => {
    let totalSum = 0;
    if (!data) return 0;
    data.products.forEach((e) => {
      totalSum += e.amount * e.price;
    });
    return numberFormat(totalSum);
  };

  const calculateTotalFact = (data) => {
    let totalSum = 0;
    if (!data) return 0;
    data.createdOrder.products.forEach((e) => {
      totalSum += e.amount * e.price;
    });
    return numberFormat(totalSum);
  };

  return data.map((e, i) => (
    <Box
      key={i}
      sx={{
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
        justifyContent: "space-between",
        bgcolor: "background.paper",
        borderBottom: "1px solid #ccc",
        padding: "10px",
      }}
    >
      <Box
        sx={{
          width: "100%",
          display: "flex",
          flexDirection: "row",
          alignItems: "center",
          gap: "10px",
        }}
      >
        <Box
          sx={{
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
            justifyContent: "center",
            width: "30px",
            height: "30px",
            backgroundColor: "rgba(3, 134, 129, 0.22)",
            borderRadius: "50%",
          }}
        >
          <Typography>{i + 1}</Typography>
        </Box>
        <Typography>{e.client ? e.client.name : e.cbClient.name}</Typography>
      </Box>
      <Box
        sx={{
          width: "100%",
          display: "flex",
          flexDirection: "row",
          justifyContent: "center",
        }}
      >
        <Typography>
          {moment(e.createdAt).format("DD.MM.YYYY HH:mm")}
        </Typography>
      </Box>
      <Box
        sx={{
          width: "100%",
          display: "flex",
          flexDirection: "row",
          alignItems: "center",
          gap: "5px",
          justifyContent: "center",
        }}
      >
        <Typography fontWeight={"bold"}>{calculateTotalPrice(e)}</Typography>
      </Box>
      <Box
        sx={{
          width: "100%",
          display: "flex",
          flexDirection: "row",
          alignItems: "center",
          gap: "5px",
          justifyContent: "center",
        }}
      >
        <Typography fontWeight={"bold"}>
          {numberFormat(e.amountPayment)}
        </Typography>
      </Box>
      <Box
        sx={{
          width: "100%",
          display: "flex",
          flexDirection: "row",
          alignItems: "center",
          gap: "5px",
          justifyContent: "center",
        }}
      >
        <Typography fontWeight={"bold"}>{calculateTotalFact(e)}</Typography>
      </Box>
      <IconButton
        onClick={() => {
          action("Buyurtmalar", e);
        }}
      >
        <MdKeyboardArrowRight />
      </IconButton>
    </Box>
  ));
};

export default Client;
